import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/map_icon_active.svg'
import _imports_1 from '@/assets/img/map_icon.svg'
import _imports_2 from '@/assets/img/list_icon_active.svg'
import _imports_3 from '@/assets/img/list_icon.svg'
import _imports_4 from '@/assets/img/search_icon.svg'


const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = { class: "d-flex align-items-center justify-content-center mb-5" }
const _hoisted_3 = { src: _imports_0 }
const _hoisted_4 = { src: _imports_1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_6 = { src: _imports_2 }
const _hoisted_7 = { src: _imports_3 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_9 = { class: "fakeInput nowrap overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_account_box = _resolveComponent("account-box")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_map_filters = _resolveComponent("map-filters")!
  const _component_list_filters = _resolveComponent("list-filters")!
  const _component_list_results = _resolveComponent("list-results")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["boxContainer filtersBox", {'pb-0': !_ctx.localShowFiltersSection, 'listOpened': _ctx.activeFilter == 'list' && _ctx.localShowFiltersSection, 'menuOpened': _ctx.menuOpened}])
    }, [
      _createVNode(_component_account_box, {
        onMenuSettingChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuOpened = $event))
      }),
      (_ctx.localShowFiltersSection)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab", {'active': _ctx.activeFilter == 'map'}]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToMap()))
              }, [
                _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
                  [_vShow, _ctx.activeFilter == 'map']
                ]),
                _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
                  [_vShow, _ctx.activeFilter == 'list']
                ])
              ], 2),
              _hoisted_5,
              _createElementVNode("div", {
                class: _normalizeClass(["tab", {'active': _ctx.activeFilter == 'list'}]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeFilter = 'list'))
              }, [
                _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
                  [_vShow, _ctx.activeFilter == 'list']
                ]),
                _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
                  [_vShow, _ctx.activeFilter == 'map']
                ])
              ], 2)
            ]),
            _createElementVNode("div", {
              class: "searchContainer pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openSearchModal()))
            }, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_localized_text, {
                  localizedKey: "LuogoBuildingNomeCognome",
                  text: "Luogo, building, nome cognome...",
                  class: "fs_14"
                })
              ])
            ]),
            (_ctx.activeFilter == 'map')
              ? (_openBlock(), _createBlock(_component_map_filters, {
                  key: 0,
                  onActiveBuildingFilterUpdated: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('activeBuildingFilterUpdated', $event))),
                  onNotActiveBuildingFilterUpdated: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('notActiveBuildingFilterUpdated', $event))),
                  onTecniciRolesFilterUpdate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('tecniciRolesFilterUpdate', $event)))
                }))
              : _createCommentVNode("", true),
            (_ctx.activeFilter == 'list')
              ? (_openBlock(), _createBlock(_component_list_filters, {
                  key: 1,
                  ticketStatusList: _ctx.ticketStatusList,
                  onClearFilters: _ctx.clearFilters,
                  onApplyFilters: _ctx.applyFilters
                }, null, 8, ["ticketStatusList", "onClearFilters", "onApplyFilters"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.activeFilter == 'list' && _ctx.localShowFiltersSection)
      ? (_openBlock(), _createBlock(_component_list_results, {
          key: 0,
          filters: _ctx.listFilter
        }, null, 8, ["filters"]))
      : _createCommentVNode("", true)
  ], 64))
}